import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=bd2d2746&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd2d2746')) {
      api.createRecord('bd2d2746', component.options)
    } else {
      api.reload('bd2d2746', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=bd2d2746&", function () {
      api.rerender('bd2d2746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hSZt4Y2Pc75N/JS/videoIframe.vue"
export default component.exports